import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-centre',
  templateUrl: './centre.component.html',
  styleUrls: ['./centre.component.scss']
})
export class CentreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
